import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path
      key='0'
      fill='#000000'
      d='M22.1,6.8c0-1.5-1.2-2.9-2.9-2.9H3.1c-0.7,0-1.4,0.7-1.4,1.4v8.7c0,1.5,1.2,2.9,2.9,2.9h0.3c0,2.5,1.8,4.3,4.3,4.3
	c2.5,0,4.3-1.8,4.3-4.3h0.3c0,2.5,1.8,4.3,4.3,4.3c2.5,0,4.3-1.8,4.3-4.3L22.1,6.8z M9,18.5c-1.1,0-1.9-0.9-1.9-1.9S8,14.6,9,14.6
	s1.9,0.9,1.9,1.9S10.1,18.5,9,18.5z M18.1,18.5c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9s1.9,0.9,1.9,1.9S19.2,18.5,18.1,18.5z'
    />,
  ],
  'TrailerRounded'
);

const TrailerRoundedIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TrailerRoundedIcon);
